export const P00076DureeTypeEnum = [
  { ref: 0, label: 'P00076.dureetype.0h' },
  { ref: 7200, label: 'P00076.dureetype.2h' },
  { ref: 14400, label: 'P00076.dureetype.4h' },
  { ref: 21600, label: 'P00076.dureetype.6h' },
  { ref: 28800, label: 'P00076.dureetype.8h' },
];
